import React, { useMemo } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useBatchDataFetcher } from '../../../hooks';
import { Container, Alert } from 'react-bootstrap';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import {
  Form,
  Well,
  FormHeading,
  ISelectOptionDataSource,
  toSelectOptions,
} from '../../../form';
import SiteForm from '../form';
import { IEditSitePageRouteParams } from './types';
import updateSite from './updateSite';
import schema from './schema';

const config = {
  transformers: [
    (data: { themes: Array<ISelectOptionDataSource> }) =>
      toSelectOptions(data.themes),
    (data: { visitorTypes: Array<ISelectOptionDataSource> }) =>
      toSelectOptions(data.visitorTypes),
    (data: { questionnaires: Array<ISelectOptionDataSource> }) =>
      toSelectOptions(data.questionnaires),
    (data: { agreements: Array<ISelectOptionDataSource> }) =>
      toSelectOptions(data.agreements),
  ],
};

const EditSitePage: React.FC = () => {
  const history = useHistory();

  const { pin } = useParams<IEditSitePageRouteParams>();

  const urls = useMemo(
    () => [
      'api/themes',
      'api/visitorTypes',
      'api/questionnaires',
      'api/visitorAgreements',
      `/api/sites/${pin}`,
    ],
    [pin],
  );

  const {
    busy,
    errors,
    data: [themes, visitorTypes, questionnairesData, agreements, site],
  } = useBatchDataFetcher(urls, config);

  return (
    <Container fluid>
      <Well>
        <FormHeading title="Site" subTitle="Edit" backPath="/admin/sites" />
        {site?.deactivated && (
          <Alert variant="warning">This site has been deactivated</Alert>
        )}
        <AjaxErrorBoundary
          busy={busy}
          loadingText={`Loading site ${pin}`}
          errors={errors}
        >
          <Form
            initialValues={site}
            promise={updateSite}
            validationSchema={schema}
            onSubmit={() => history.push('/admin/sites')}
          >
            <SiteForm
              themes={themes}
              visitorTypes={visitorTypes}
              questionnaires={questionnairesData}
              agreements={agreements}
            />
          </Form>
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};

export default EditSitePage;
